import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import {
  normalizeStockReportSummaryPayload,
  normalizeStockReportTablePayload,
} from '../../../helpers/normalizeStockReportResponse';

const initialState = {
  loading: false,
  summary: {},
  productList: { data: [], total: 0, per_page: 10, current_page: 1 },
  error: '',
};

export const fetchStocksSummary = createAsyncThunk(
  'stockReport/fetchStocksSummary',
  (params = {}) => {
    return ReportService.getStocksReport(
      normalizeReportParams({ ...params, view: 'summary', format: 'json' })
    ).then((res) => res);
  }
);

export const fetchStocksTable = createAsyncThunk(
  'stockReport/fetchStocksTable',
  (params = {}) => {
    return ReportService.getStocksReport(
      normalizeReportParams({ ...params, view: 'table', format: 'json' })
    ).then((res) => res);
  }
);
const stockCountSlice = createSlice({
  name: 'stockReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchStocksSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStocksSummary.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.summary = normalizeStockReportSummaryPayload(payload);
      state.error = '';
    });
    builder.addCase(fetchStocksSummary.rejected, (state, action) => {
      state.loading = false;
      state.summary = {};
      state.error = action.error.message;
    });

    builder.addCase(fetchStocksTable.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStocksTable.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.productList = normalizeStockReportTablePayload(payload);
      state.error = '';
    });
    builder.addCase(fetchStocksTable.rejected, (state, action) => {
      state.loading = false;
      state.productList = initialState.productList;
      state.error = action.error.message;
    });
  },

  reducers: {
    filterStockProduct() {},
  },
});
export const { filterStockProduct } = stockCountSlice.actions;
export default stockCountSlice.reducer;
